import { render, staticRenderFns } from "./UserPauseAccount.vue?vue&type=template&id=5bd74a90"
import script from "./UserPauseAccount.vue?vue&type=script&lang=js"
export * from "./UserPauseAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports